export default __webpack_public_path__ + "static/media/Wallet.47d7a416.svg";